<template lang="pug">
.panel.panel-default
  .panel-heading
    .row
      .col-md-6
        h4(style="margin-top: 7px") Custom Export Fields
      .col-md-6.text-right
        HelpPopover(title="Custom Export Fields" :content="helpText" placement="left")
        ShowHideButton.btn-sm(v-model="showFields")
  .panel-body(v-show="showFields")
    p.text-muted(v-if="storyCustomFieldsStore.all.length === 0")
      | No custom fields defined. Click the button below to add one.
    CustomExportField(
      v-for="field in storyCustomFieldsStore.all"
      :story-custom-field-id="field.id"
      :key="field.id"
    )
    .text-right
      button.btn.btn-link(type="button" @click="addNew()")
        i.fa.fa-plus
        |
        | Add custom field
</template>

<script>
  import { mapStores } from 'pinia'
  import { useStoryCustomFieldsStore } from '@/stores/story_custom_fields'
  import CustomExportField from './custom_export_field.vue'
  import HelpPopover from '@/components/shared/help_popover.vue'
  import ShowHideButton from '@/components/show_hide_button.vue'

  export default {
    components: {
      CustomExportField,
      HelpPopover,
      ShowHideButton
    },

    props: {
      storyId: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        showFields: true,
        helpText: 'Define custom name/value pairs that can be used in export templates. Field names must start with a letter and contain only lowercase letters, numbers, and underscores. Use these in Liquid templates as {{ story.custom_fields.field_name }}.'
      }
    },

    computed: {
      ...mapStores(useStoryCustomFieldsStore),
    },

    watch: {
      storyId(newStoryId) {
        this.storyCustomFieldsStore.reset()
        this.storyCustomFieldsStore.fetchForStory(newStoryId)
      }
    },

    mounted() {
      this.storyCustomFieldsStore.fetchForStory(this.storyId)
    },

    beforeDestroy() {
      this.storyCustomFieldsStore.reset()
    },

    methods: {
      addNew() {
        this.storyCustomFieldsStore.addLocal()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .panel-body {
    .text-muted {
      margin-bottom: 1em;
    }
  }
</style>
